import { useParallax } from '../../PromptCard/useParallax';

type UseAchievementCardHoverProps = {
    needHover: boolean;
    backgroundImageUrl: string;
    owned: boolean;
};

export const useAchievementCardParallax = ({ needHover, backgroundImageUrl, owned }: UseAchievementCardHoverProps) => {
    const { panelRef, transformX, transformY } = useParallax(1);

    const parallaxStyle = {
        transform: `perspective(200px) rotateY(${transformX}deg) rotateX(${transformY}deg)`,
    };

    const cardParallaxStyle = needHover ? parallaxStyle : {};

    const backgroundStyle = {
        '--bg-image': owned ? `url(${backgroundImageUrl})` : '',
    } as React.CSSProperties;

    return {
        panelRef,
        cardParallaxStyle,
        backgroundStyle,
    };
};
